//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExpress Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports

import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base';
import { IMRToolbarOptions } from '@imr/controls.angularjs/components/toolbar';
import { IMRPopupOptions, IIMRPopup } from '@imr/controls.angularjs/components/overlay/popup';

//#endregion


import { TypeHelper, LocalizationHelper, LogHelper, EventsNames } from '../../../../helpers'
import { PopupHelper } from '../../../../helpers/popup-helper'
import { GridController, GridOptions, GridTypes } from '../../../common/grid'
import { OpTariff, OpLocation, OpDataTypeInGroup, OpDevice } from '../../../../models/core'
import { UserSessionService } from '../../../../services/user-session'
import { TariffService, TariffLocationsService } from '../../../../services/tariff'
import { IOpObject } from '../../../../models/util/interfaces'
import { ColumnModel } from '../../../api/api.models'
import { Enums, Activity } from '../../../../models/common'
import { DetailsParametersOptions } from '../../../common/details-parameters/details-parameters.directive'
import { ConfirmationOptions } from '../../../common/confirmation-popup/confirmation-popup.directive'
import { ActionHelper } from '../../../../helpers/action-helper'
import { ActionStatusOptions } from '../../../common/action-status/action-status.controller'


export interface TariffCopySummaryOptions {
    deferred: JQueryDeferred<IOpObject>
    copyFrom: OpTariff
    copyTo: OpTariff
}

export class TariffCopySummaryController
    implements ng.IComponentController {

    // #region Consts  
    private TARIFF_COPY_SUMMARY_LOCATIONS_GRID_NAME: string = 'tariffCopySummaryLocationsGrid'

    // #endregion

    // #region Members

    //#region input parameters

    private options: TariffCopySummaryOptions

    //#endregion

    public imrPopupOptions: IMRPopupOptions
    public gridOptions: GridOptions
    public tariffCopyFromDetailsParametersOptions: DetailsParametersOptions
    public tariffCopyToDetailsParametersOptions: DetailsParametersOptions
    public sendConfigurationConfirmationPopupOptions: ConfirmationOptions
    public askDeactivateTariffPopupOptions: ConfirmationOptions
    public askClosePopupOptions: ConfirmationOptions
    public sendConfigurationPopupId: string
    public askDeativatePopupId: string
    public askClosePopupId: string
    public copyFromText: string
    public copyToText: string


    private imrPopup: IIMRPopup
    private sendConfigurationClicked: boolean
    private submitButton: DevExpress.ui.dxButton
    private submitClicked: boolean
    private gridController: GridController<OpLocation>
    private dxGrid: DevExpress.ui.dxDataGrid
    private deactivateTariff: boolean = false
    private deactivateDeferr: JQueryDeferred<boolean>
    private sendConfigurationButton: DevExpress.ui.dxButton
    private sendConfigurationDeferr: JQueryDeferred<boolean>
    private isCopyFailed: boolean


    //#endregion

    // #region Ctor

    constructor(
        private $rootScope: ng.IRootScopeService,
        private userSessionService: UserSessionService,
        private tariffService: TariffService,
        private tariffLocationsService: TariffLocationsService
    ) {
        this.setPopupOptions()
        this.setBaseOptions()
    }

    //#region Ctor


    //#endregion


    //#region IComponentController Implementation

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.showPopup()
            this.initialize()
        }
    }

    //#endregion

    // #endregion

    // #region

    private showPopup(): void {
        if (this.popupExists()) {
            this.imrPopup.show()
        } else {
            LogHelper.error(TariffService.LOG_PREFIX, `Can't show popup - popup doesn't exist`)
        }
    }

    private hidePopup(): void {
        if (this.popupExists()) {
            this.imrPopup.hide()
        }
    }

    public showLoader(): void {
        if (this.popupExists()) {
            this.imrPopup.toggleLoading(true)
        }
    }

    public hideLoader(): void {
        if (this.popupExists()) {
            this.imrPopup.toggleLoading(false)
        }
    }

    // #endregion

    // #region Lifecycle    

    private hiding(e: any): void {
        if (this.submitClicked && !this.sendConfigurationClicked && this.hasDevices() && !this.isCopyFailed) {
            e.cancel = true

            this.askClosePopup()
        }
    }

    private initialize(): void {
        this.showLoader()

        this.setOptions()

        this.setGridOptions()

        this.setSendConfigurationButtonState()

        if (this.submitButton != null) {
            this.submitButton.option({ disabled: false })
        }
    }

    // #endregion

    // #region Events

    private onHidden(): void {
        if (this.submitClicked != true) {
            this.options.deferred.reject()
        }

        this.sendConfigurationClicked = false
        this.submitClicked = false
        this.gridOptions = null
        this.deactivateTariff = false
    }

    private onGridInitialized(gridController: GridController<OpLocation>): void {
        this.gridController = gridController
        this.dxGrid = this.gridController.dxGrid

        this.hideLoader()
    }

    private onSubmitClick(): void {
        this.submitClicked = true
        this.isCopyFailed = false
        this.deactivateDeferr = $.Deferred()

        const isTariffActive: boolean = this.options.copyFrom.dataList != null ? this.options.copyFrom.dataList.getValue(Enums.DataType.TARIFF_IS_ACTIVE) : false
        if (isTariffActive == true && this.userSessionService.getLoggedOperator().hasPermission(Activity.TARIFF_EDIT)) {
            this.askDeactivateSourceTariff()
        } else {
            this.deactivateDeferr.resolve(false)
        }

        this.deactivateDeferr
            .then((needDeactivate: boolean) => {
                this.options.copyTo.currentLocations = []
                if (_.size(this.options.copyFrom.currentLocations) > 0) {
                    this.options.copyTo.currentLocations = this.options.copyFrom.currentLocations.map((opLocation: OpLocation) => {
                        const location: OpLocation = new OpLocation(null)
                        location.copy(opLocation, false, false, true, false)
                        location.opState = Enums.OpChangeState.New
                        return location
                    })
                }

                this.showLoader()
                if (needDeactivate) {
                    if (this.options.copyFrom.dataList != null) {
                        this.options.copyFrom.dataList.setValue(false, Enums.DataType.TARIFF_IS_ACTIVE)
                    }

                    this.saveTariff(this.options.copyFrom)
                        .then(() => {
                            this.copyTariff(this.options.copyTo)
                                .then((tariff: OpTariff) => {
                                    this.onTariffSaved(tariff)
                                })
                                .fail((ex: any) => {
                                    this.isCopyFailed = true
                                    this.hideLoader()
                                    this.options.deferred.reject()
                                })
                        })
                } else {
                    this.copyTariff(this.options.copyTo)
                        .then((tariff: OpTariff) => {
                            this.onTariffSaved(tariff)
                        })
                        .fail((ex: any) => {
                            this.isCopyFailed = true
                            this.hideLoader()
                            this.options.deferred.reject()
                        })
                }
            })
    }

    private onTariffSaved(tariff: OpTariff): void {
        this.options.deferred.resolve(tariff)
        if (this.hasDevices()) {
            this.setSendConfigurationButtonState()
            this.hideLoader()
        } else {
            this.hidePopup()
        }
    }

    private onSendDeviceConfiguration(): void {
        this.showLoader()
        const devices: OpDevice[] = []
        if (_.size(this.options.copyFrom.currentLocations) > 0) {
            this.options.copyFrom.currentLocations.forEach((location: OpLocation) => {
                if (_.size(location.currentDevices) > 0) {
                    location.currentDevices.forEach((device: OpDevice) => {
                        devices.push(device)
                    })
                }
            })
        }
        ActionHelper
            .sendDeviceConfiguration(this.userSessionService.getDataProvider(), devices)
            .then((actionStatusOptions: ActionStatusOptions) => {
                this.$rootScope.$broadcast(EventsNames.SHOW_ACTION_STATUS_POPUP + this.sendConfigurationPopupId, actionStatusOptions)
                this.hideLoader()
            })
    }

    private saveTariff(toSave: OpTariff): JQueryPromise<OpTariff> {
        return this.tariffService.saveTariff(toSave, TariffService.SIMAX_MODULE_NAME, true)
    }

    private copyTariff(toSave: OpTariff): JQueryPromise<OpTariff> {
        return this.tariffService.copyTariff(toSave, TariffService.SIMAX_MODULE_NAME)
    }

    private askDeactivateSourceTariff(): void {
        this.$rootScope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.askDeativatePopupId,
            this.askDeactivateTariffPopupOptions
        )
    }

    private askSendConfigurationToDevices(): void {
        this.$rootScope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.sendConfigurationPopupId,
            this.sendConfigurationConfirmationPopupOptions
        )
    }

    private askClosePopup(): void {
        this.$rootScope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.askClosePopupId,
            this.askClosePopupOptions
        )
    }

    private onConfirmSendConfiguration(): void {
        this.sendConfigurationClicked = true
        this.onSendDeviceConfiguration()
    }

    private onDeactivateTariff(): void {
        this.deactivateTariff = true
        this.deactivateDeferr.resolve(true)
    }

    private onSendConfigurationButtonInitialized(e: any): void {
        this.sendConfigurationButton = e.component
        this.setSendConfigurationButtonState()
    }

    // #endregion

    // #region Setup    

    private setPopupOptions(): void {
        this.imrPopupOptions = {
            innerOptions: PopupHelper.mergeWithDefaultOptions({
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CopyTariffSummary),

                maxWidth: (): number => { return $(window).width() * 0.7 },
                height: (): number => { return $(window).height() * 0.9 },

                onHiding: (e: any) => { this.hiding(e) },
                onHidden: () => { this.onHidden() },
            }),

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            },

            bottomToolbarOptions: this.getPopupToolbarOptions()
        }
    }

    private setBaseOptions(): void {
        this.askDeativatePopupId = TypeHelper.guid()
        this.sendConfigurationPopupId = TypeHelper.guid()
        this.askClosePopupId = TypeHelper.guid()

        this.copyFromText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CopyFrom)
        this.copyToText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.CopyTo)

        this.sendConfigurationConfirmationPopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            question: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),

            onConfirmed: () => { this.onConfirmSendConfiguration() },
            onDeclined: () => { this.sendConfigurationDeferr.resolve(false) }
        }

        this.askDeactivateTariffPopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            question: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.DeactivateSourceTariffQuestion),

            onConfirmed: () => { this.onDeactivateTariff() },
            onDeclined: () => { this.deactivateDeferr.resolve(false) }
        }

        this.askClosePopupOptions = {
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm),
            question: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ClosePopupWithoutSendingConfigurationQuestion),

            onConfirmed: () => {
                this.sendConfigurationClicked = true
                this.hidePopup()
            }
        }
    }

    private setOptions(): void {
        this.tariffService.getBasicParametersDataTypeGroup()
            .then((dataTypeInGroup: OpDataTypeInGroup[]) => {
                this.tariffCopyFromDetailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: TariffService.REFERENCE_TYPE,
                    referenceObject: this.options.copyFrom
                }

                this.tariffCopyToDetailsParametersOptions = {
                    dataTypes: dataTypeInGroup,
                    referenceType: TariffService.REFERENCE_TYPE,
                    referenceObject: this.options.copyTo
                }
            })
    }

    private setSendConfigurationButtonState(): void {
        if (this.sendConfigurationButton != null) {
            this.sendConfigurationButton.option({ disabled: !this.hasDevices() || !this.submitClicked })
        }
    }

    private setGridOptions(): void {

        this.tariffLocationsService.getTariffLocationsParameters()
            .then((columns: ColumnModel[]) => {

                this.gridOptions = {
                    name: this.TARIFF_COPY_SUMMARY_LOCATIONS_GRID_NAME,
                    idReferenceType: Enums.ReferenceType.IdLocation,
                    type: GridTypes.PAGINATED_SMALL,
                    buttonsOptions: {
                        enabled: true,
                    },
                    addCustomFilters: true,
                    dataSource: _.size(this.options.copyFrom.currentLocations) > 0 ? this.options.copyFrom.currentLocations : [],
                    columnsDictionary: columns,
                    allowColumnReordering: !this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.TariffLocations),
                    onInitialized: (e: any, grid: GridController<OpLocation>) => { this.onGridInitialized(grid) }
                }
            })
    }

    private getPopupToolbarOptions() {
        const imrToolbarOptions: IMRToolbarOptions = {
            innerOptions: {
                items: [
                    {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SendConfigurationToDevice),
                            onClick: () => {
                                this.askSendConfigurationToDevices()
                            },
                            onInitialized: (e: any) => {
                                this.onSendConfigurationButtonInitialized(e)
                            }
                        }
                    }, {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Save),
                            onClick: (e: any) => {
                                this.onSubmitClick()
                                e.component.option({ disabled: true })
                            },
                            onInitialized: (e: any) => {
                                this.submitButton = e.component
                            }
                        }
                    }
                ]
            }
        }

        return imrToolbarOptions
    }

    // #endregion

    // #region Flags   

    private popupExists(): boolean {
        return this.imrPopup != null
    }

    private hasDevices(): boolean {
        if (
            this.options != null &&
            _.size(this.options.copyFrom.currentLocations) > 0
        ) {
            return this.options.copyFrom.currentLocations.some((location: OpLocation) => _.size(location.currentDevices) > 0)
        }

        return false
    }

    // #endregion
}
